import { generateTable } from '../../table/Table';
import { fetchAgentComponents } from '../../../apis';

var dataSource = function dataSource() {
  return {
    fn: fetchAgentComponents,
    clientSide: true,
    params: function params() {
      return [];
    },
    transform: function transform(result) {
      return {
        data: result.agents
      };
    }
  };
};

var columns = [{
  value: 'slug',
  title: 'Agent Slug',
  sortable: true
}, {
  value: 'url',
  title: 'Agent Url',
  sortable: false
}];
export var AgentComponentTable = generateTable({
  columns: columns,
  dataSource: dataSource
});
AgentComponentTable.displayName = 'AgentComponentTable';